/**
 * https://wiki.inhr.cc/wiki/#/team/6GaqfmSn/space/E1XQPKUP/page/ATWTQYp5
 */
export const _cookie = {
  TOKEN: "__sdichome_token__", // 国投幸福家的token
  USER_INFO_FAMILY_ACCOUNT: "__sdichome_userinfo_isFamilyAccount", //是否为亲友号
};

export const _storage = {
  SHOPPING_CART: "sdic-home-car", // 购物车
  IS_ANSWERED: "is-answered", // 是否已答过题
};

export const _route = {
  INDEX: "/",
  LOGIN: "/login",
  ALI_CAPTCHA: "/aliCaptcha",
  FILE_REVIEW: "/file-review",
  // 订餐
  CATERING: "/catering", // 订餐首页
  CATERING_DETAIL: "/catering/detail", // 餐品详情
  CATERING_CART: "/catering/cart", // 订餐购物车
  CATERING_ORDER: "/catering/order", // 订餐订单列表
  CATERING_ORDER_WAITING: "/catering/order/waiting", // 订餐订单等待页
  CATERING_ORDER_DETAIL: "/catering/order/detail", // 订单详情

  // 消息
  MESSAGE: "/message", // 消息首页
  MESSAGE_DETAIL: "/message/detail", // 消息详情页
  MESSAGE_TREND: "/message/trend", // 动态消息
  MESSAGE_TREND_AUDIT: "/message/trend-audit", // 动态消息的审核

  // 动态审核
  TREND_AUDIT: "/trend-audit", // 待审核和已审核的tab列表
  TREND_AUDIT_DETAIL: "/trend-audit/detail", // 审核动态的详情
  TREND_AUDIT_LOG: "/trend-audit/log", // 审核的记录

  // 动态
  TREND_DETAIL: "/trend/detail", // 动态详情

  // 菜单查询
  MENU: "/menu",

  // 招待所
  HOTEL: "/hotel",

  // 心理关怀
  PSYCHOLOGY: "/psychology", // 测评首页
  PSYCHOLOGY_HALL: "/psychology/hall", // 测评大厅
  PSYCHOLOGY_REPORT: "/psychology/report", // 测评报告
  // 服务中心
  SERVICE: "/service",
  // 赋能中心
  EMPOWER: "/empower",
  // 赋能中心-集团杂志页面
  EMPOWER_BOOK_HOUSE: "/empower/book-house",
  // 活动中心
  ACTIVITY: "/activity",
  // 活动证书
  ACTIVITY_CERTIFICATE: "/activity-certificate",
  // 蓝天超市
  MARKET: "/market",
  // pdf预览
  PDF: "/pdf",
  // 徽章
  BADGE: "/badge",

  APP: "/app",
  // 介绍
  ABOUT: "/about",

  NOT_FOUND: "/not-found",

  // 直播分享
  LIVE: "/live",

  // 物业信箱
  MAIL_BOX: "/mailbox",

  // 协议
  DOC: "/doc",
  // 文章（需要登录）
  ARTICLE: "/article",
  ARTICLE_TRANSFER: "/article/transfer",

  // 交易记录
  FLOW: "/flow",

  // 健步走
  WALK: "/walk",
  WALK_HISTORY: "/walk/history", // 历史步数
  WALK_RANK: "/walk/rank", // 排行榜
  // 健步走三十周年
  WALK_LEVEL: "/walk/level-thirty",
  // 2026新年活动
  WALK_NEW_YEAR: "/walk/new-year",
  // 2026农历新年
  WALK_LUNAR_NEW_YEAR: "/walk/lunar-new-year",
  // 2026书香伴我行
  WALK_BOOK: "/walk/sxbwxjbz",
  // 2026中秋活动
  WALK_MONTH_2026: "/walk/moon-elel",

  POINTS: "/points", // 积分明细
  POINTS_RANK: "/points/rank", // 积分排行榜

  //心愿
  WISH: "/wish", // 心愿列表
  WISH_DETAIL: "/wish/detail", // 心愿详情
  WISH_ADD: "/wish/add", // 添加心愿

  // 创智中心
  CREATIVE_CENTER: "/creative-center",
  CREATIVE_CENTER_HOME: "/creative-center/home",
  CREATIVE_CENTER_CHUANGXIN: "/creative-center/chuangxin",
  CREATIVE_CENTER_ZHUIGUANGLING: "/creative-center/zhuiguangling",
  CREATIVE_CENTER_ZHUIGUANGLING_DETAIL: "/creative-center/zhuiguangling/detail",
  CREATIVE_CENTER_ZHUIGUANGLING_PUBLISH: "/creative-center/zhuiguangling/publish",
  CREATIVE_CENTER_MODULE: "/creative-center/module",
  CREATIVE_CENTER_MODULE_DETAIL: "/creative-center/module/detail",
  CREATIVE_CENTER_RAPID_TEAM: "/creative-center/rapid-team", // 突击队
  CREATIVE_CENTER_RAPID_TEAM_DETAIL: "/creative-center/rapid-team/detail", // 突击队详情
  CREATIVE_CENTER_TEAM: "/creative-center/team", // 班组建设
  CREATIVE_CENTER_TEAM_DETAIL: "/creative-center/team/detail", // 班组建设详情
  CREATIVE_CENTER_RACE: "/creative-center/race", // 创新创效大赛
  CREATIVE_CENTER_RACE_DETAIL: "/creative-center/race/detail", // 创新创效大赛详情
  CREATIVE_CENTER_WORKSHOP: "/creative-center/workshop", // 创新工作室
  CREATIVE_CENTER_WORKSHOP_DETAIL: "/creative-center/workshop/detail", // 创新工作室详情
  CREATIVE_CENTER_WORKSHOP_NEW: "/creative-center/workshop/new", // 新增创新工作室
  CREATIVE_CENTER_WORKSHOP_EDIT: "/creative-center/workshop/edit", // 编辑创新工作室
  CREATIVE_CENTER_WORKSHOP_ZEN_LIST: "/creative-center/workshop/zen/list", // 点赞列表
  CREATIVE_CENTER_WORKSHOP_MEMBER_MANAGE: "/creative-center/workshop/member/manage", // 管理成员
  CREATIVE_CENTER_WORKSHOP_MEMBER_APPLY_LIST: "/creative-center/workshop/member/apply-list", // 成员申请
  CREATIVE_CENTER_WORKSHOP_MEMBER_APPLY: "/creative-center/workshop/member/apply", // 提交申请
  CREATIVE_CENTER_WORKSHOP_MEMBER_ADD: "/creative-center/workshop/member/add", // 添加成员
  CREATIVE_CENTER_WORKSHOP_MEMBER_SEARCH: "/creative-center/workshop/member/search", // 搜索成员
  CREATIVE_CENTER_WORKSHOP_APPROVAL_RESULT: "/creative-center/workshop/approval-result", // 审核结果

  // 困补申请
  HARDSHIP_AID: "/hardship-aid",
  HARDSHIP_AID_APPLY: "/hardship-aid/apply",
  HARDSHIP_AID_RECORD: "/hardship-aid/record",
  // 文体活动
  RECREAT_ACTIVITY: "/recreational-activities",
  RECREAT_ACTIVITY_APPLY: "/recreational-activities/apply",
  RECREAT_ACTIVITY_RECORD: "/recreational-activities/record",

  // 文体协会
  ASSOCIATION: "/association",
  ASSOCIATION_HOME: "/association/home",
  ASSOCIATION_DETAIL: "/association/detail",
  ASSOCIATION_PERSONAL: "/association/personal",
  ASSOCIATION_PERSONAL_CONTACT: "/association/personal/contact", // 紧急联系人
  ASSOCIATION_PERSONAL_JOINED: "/association/personal/joined", // 我参与的
  ASSOCIATION_MANAGEMENT: "/association/management", // 协会管理
  ASSOCIATION_MANAGEMENT_COURSE_EDIT: "/association/management/course-edit", // 协会管理-课程编辑
  ASSOCIATION_MANAGEMENT_COURSE_INFO: "/association/management/course-info", // 协会管理-课程编辑
  ASSOCIATION_MANAGEMENT_ACTIVITY_EDIT: "/association/management/activity-edit", // 协会管理-活动编辑
  ASSOCIATION_MANAGEMENT_ACTIVITY_INFO: "/association/management/activity-info", // 协会管理-活动编辑
  ASSOCIATION_MANAGEMENT_MEMBER_INFO: "/association/management/member-info", // 协会管理-成员信息
  COURSE_ACTIVITY_CALENDAR: "/association/course-activity-calendar", // 课程活动日历
  COURSE_ACTIVITY_DETAIL: "/association/course-activity-detail", // 课程活动详情
  COURSE_CHECKIN: "/association/course-checkin", // 课程签到页
  COURSE_CHECKIN_RESULT: "/association/course-checkin-result", // 课程签到结果
  COURSE_ACTIVITY_MY_APPOINTMENT: "/association/my-appointment", // 查看我的预约页
  COURSE_ADD_MEMBER: "/association/course-add-member", // 添加成员页面

  // 工会信箱
  POSTBOX: "/postbox",

  // 关爱中心
  CARE: "/care",
  CARE_ORDER: "/care/order",
  CARE_ORDER_LIST: "/care/order/list",
  CARE_ADDRESS: "/care/address", // 收货地址
  CARE_ADDRESS_EDIT: "/care/address/edit", // 收货地址
  CARE_MEMBER: "/care/member", // 会员中心
  CARE_EXCHANGE: "/care/exchange", // 消费券
  CARE_EXCHANGE_LIST: "/care/exchange/list", // 消费券列表
  CARE_WELFARE_CLAIM: "/care/welfare-claim", // 福利申领记录
  CARE_WELFARE_CLAIM_FILL: "/care/welfare-claim/fill", // 福利申领填写
  CARE_WELFARE_CLAIM_CONFIRM: "/care/welfare-claim/confirm", // 福利申领确认

  // 资讯中心
  NEWS: "/news",
  NEWS_LIST: "/news/list",
  NEWS_DETAIL: "/news/detail",

  // 个人信息
  MINE: "/mine",
  MINE_USER_INFO: "/mine/user-info",
  MINE_UNION_INFO: "/mine/union-info",
  MINE_REWARD: "/mine/reward",
  MINE_REWARD_FORM: "/mine/reward/form",
  MINE_FAMILY: "/mine/family",
  MINE_FAMILY_FORM: "/mine/family/form",
  MINE_FAMILY_MEMBER: "/mine/family/member", // 亲情号

  MEMORY: "/memory/year", // 年度记忆
  LUCKY_WHEEL: "/lucky-wheel", // 幸运大转盘

  // 地址
  ADDRESS: "/address",
  ADDRESS_LIST: "/address/list",
  ADDRESS_ADD: "/address/add",
  ADDRESS_EDIT: "/address/edit",

  // 投票
  VOTE: "/vote",
  VOTE_LIST: "/vote/list",
  VOTE_DETAIL: "/vote/detail",
  VOTE_RECORD: "/vote/record", // 投票记录

  // 长安汽车活动
  CHANG_AN: "/chang-an",
  // 长安汽车活动福利宣传页
  CHANG_AN_PUBLICITY: "/chang-an/publicity",
  // 长安汽车车型消费券
  CHANG_AN_VOUCHER: "/chang-an/voucher",

  // 供应商集采
  SUPPLIER_COLLECTION: "/supplier-collection",

  // 京东内部跳转-工会商城选择
  JD_INTERNAL_REDIRECT: "/jd-internal-redirect",
};

export const universalLinkHost = "https://sdichome.iguopin.com";

// 站点统计
export const _stat = {
  cnzz: "https://s4.cnzz.com/z_stat.php?id=1281406262&web_id=1281406262",
  // cnzz: "https://s9.cnzz.com/z.js?id=1281406262",
};

// 电话区号
// export const areaCode = [
//   ["86", "中国", "+86"],
//   ["852", "中国香港", "+852"],
//   ["853", "中国澳门", "+853"],
//   ["886", "中国台湾", "+886"],
//   ["1", "美国&加拿大", "+1"],
//   ["65", "新加坡", "+65"],
//   ["61", "澳大利亚", "+61"],
//   ["44", "英国", "+44"],
//   ["60", "马来西亚", "+60"],
//   ["82", "韩国", "+82"],
//   ["33", "法国", "+33"],
//   ["64", "新西兰", "+64"],
//   ["49", "德国", "+49"],
//   ["81", "日本", "+81"],
//   ["34", "西班牙", "+34"],
//   ["39", "意大利", "+39"],
// ];
